export enum WinningMandateStep {
  GetStarted = 1,
  SellerInfo = 2,
  YourProfile = 3,
  Send = 4,
}

export interface WinningMandateLocation {
  lat?: number;
  lon?: number;
  countryCode?: string;
  postalCode?: string;
  city?: string;
  street?: string;
  formattedAddress?: string;
}

export interface WinningMandateFormData {
  sellerFirstName: string;
  sellerLastName: string;
  propertyAddress: WinningMandateLocation | null;
  includeLocationReport: boolean;
  includeHedonicValuation: boolean;
  hedonicValuationFile: File | null;
}
